"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _scroll = require("redux/modules/scroll");

var scrollActions = _interopRequireWildcard(_scroll);

var _components = require("components");

var _carousel = require("./carousel.scss");

var _carousel2 = _interopRequireDefault(_carousel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SLICK_BUTTONS = {
  PREV: '<i class="slick-custom-button prev" onClick={this.btnPrevSlider}><span class="icon-arrow"></span></i>',
  NEXT: '<i class="slick-custom-button next"><span class="icon-arrow"></span></i>'
};

var Carousel = (_dec = (0, _reactRedux.connect)(function (state, props) {
  return {
    isMobile: state.mobile.isMobile,
    isTablet: state.mobile.isTablet,
    isApple: state.mobile.isApple,
    carouselScroll: state.scroll.carouselScroll
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)((0, _extends3.default)({}, scrollActions), dispatch);
}), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(Carousel, _React$Component);

  function Carousel(props, context) {
    (0, _classCallCheck3.default)(this, Carousel);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Carousel.__proto__ || (0, _getPrototypeOf2.default)(Carousel)).call(this, props, context));

    _this.state = {
      anioActive: null,
      slickItemActive: 0,
      mute: false
    };

    _this.slick = null;

    _this.contLasItem = 0;

    _this.animation = false;
    _this.touchStart = null;
    _this.carouselActive = true;
    _this.bEventScroll = false;

    _this.videoActiveRef = _react2.default.createRef();

    _this.slickCall = _this.slickCall.bind(_this);
    _this.slickInit = _this.slickInit.bind(_this);
    _this.slickEvent = _this.slickEvent.bind(_this);
    _this.slickBeforeChange = _this.slickBeforeChange.bind(_this);
    _this.handleCarouselChangeYear = _this.handleCarouselChangeYear.bind(_this);
    _this.handleCarouselChangeMute = _this.handleCarouselChangeMute.bind(_this);
    _this.nextSlider = _this.nextSlider.bind(_this);
    _this.prevSlider = _this.prevSlider.bind(_this);

    _this.scroll = _this.scroll.bind(_this);
    _this._eventScroll = _this._eventScroll.bind(_this);
    _this.navigateScroll = _this.navigateScroll.bind(_this);
    _this._carouselScrollPrevSection = _this._carouselScrollPrevSection.bind(_this);

    _this.btnPrevSlider = _this.btnPrevSlider.bind(_this);

    _this.handleAddOnBlurListener = _this.handleAddOnBlurListener.bind(_this);
    _this.muteAudioAddOnBlurListener = _this.muteAudioAddOnBlurListener.bind(_this);
    _this.unMuteAudioAddOnBlurListener = _this.unMuteAudioAddOnBlurListener.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Carousel, [{
    key: "slickInit",
    value: function slickInit(slick) {
      // console.log("initialize");

    }
  }, {
    key: "slickEvent",
    value: function slickEvent(event, slick, direction) {
      // console.log(direction);
      if ((direction === "up" || direction === "right") && this.state.slickItemActive === 0) {
        if (this.contLasItem === 0) {
          this.contLasItem++;
        } else {
          // console.log("llegado al principio del todo y realizado scroll arriba");
          this._eventScroll(false);
          this._carouselScrollPrevSection();
        }
      } else if ((direction === "down" || direction === "left") && this.state.slickItemActive === 2) {
        if (this.contLasItem === 0) {
          this.contLasItem++;
        } else {
          // console.log("llegado al final del todo y realizado scroll abajo");
        }
      } else {
        this.contLasItem = 0;
      }
    }
  }, {
    key: "slickBeforeChange",
    value: function slickBeforeChange(event, slick, currentSlide, nextSlide) {
      // console.log(nextSlide);
      if (this.props.isApple) {
        // this.mute(false);
        $('video').prop('muted', true);
        $('.containerVideo--active').removeClass('containerVideo--active');
      }
      this.setState({
        slickItemActive: nextSlide
      });
      // this.initVideosCarouselActive(nextSlide);
    }
  }, {
    key: "nextSlider",
    value: function nextSlider() {
      this.slick.slick("slickNext", 1);
    }
  }, {
    key: "prevSlider",
    value: function prevSlider() {
      this.slick.slick("slickPrev", 1);
    }
  }, {
    key: "btnPrevSlider",
    value: function btnPrevSlider() {
      console.log("prev slider click");
      if (this.state.slickItemActive === 0) {
        if (this.contLasItem === 0) {
          this.contLasItem++;
        } else {
          // console.log("llegado al principio del todo y realizado scroll arriba");
          this._eventScroll(false);
          this._carouselScrollPrevSection();
          this.contLasItem = 0;
        }
      } else {
        this.contLasItem = 0;
      }
    }
  }, {
    key: "handleCarouselChangeYear",
    value: function handleCarouselChangeYear(anio) {
      // console.log(anio);
      this.setState({
        anioActive: anio
      });
    }
  }, {
    key: "handleCarouselChangeMute",
    value: function handleCarouselChangeMute(boolean) {
      this.setState({
        mute: boolean
      });
    }
  }, {
    key: "slickCall",
    value: function slickCall() {
      var _this2 = this;

      setTimeout(function () {
        // window.dispatchEvent(new Event('resize'));

        var isMobile = _this2.props.isMobile;

        var prevArrow = SLICK_BUTTONS.PREV;
        var nextArrow = SLICK_BUTTONS.NEXT;
        var useSlickDots = isMobile ? false : true;

        if (isMobile) {
          _this2.slick = $(".slick-slider").slick({
            dots: useSlickDots,
            infinite: false,
            vertical: true,
            verticalSwiping: true,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            speed: 1000
          });
        } else {
          _this2.slick = $(".slick-slider").slick({
            dots: useSlickDots,
            infinite: false,
            vertical: false,
            verticalSwiping: false,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            speed: 1000
          });
        }

        _this2.slick.on("init", function (event, slick) {
          _this2.slickInit(slick);
        });

        // On swipe event
        _this2.slick.on("swipe", function (event, slick, direction) {
          _this2.slickEvent(event, slick, direction);
        });

        // On before slide change
        _this2.slick.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
          _this2.slickBeforeChange(event, slick, currentSlide, nextSlide);
        });

        // Tooltip:
        _this2.createTooltips();
      }, 100);

      setTimeout(function () {
        $(".slick-custom-button.prev").on("click", function () {
          _this2.btnPrevSlider();
        });
      }, 1000);
    }
  }, {
    key: "createTooltips",
    value: function createTooltips() {
      var tooltipData = this.props.strings.carousel;

      // Crear el dom por única vez:
      $(".slick-dots").children("li").each(function (i) {
        var text = tooltipData[i] ? tooltipData[i].videos[0].subTitle : "Créditos";

        $(this).prepend("<div class='tooltip'><div class='square'></div><p>" + text + "</p></div>");
      });

      // Escuchar On mouse over:
      $(".slick-dots li").on("mouseover", function (e) {
        // Ocultar todos los tooltips:
        $(".tooltip").css("visibility", "hidden");

        // Mostrar el tooltip actual:
        var tooltip = $(this).children(".tooltip");
        tooltip.css({
          visibility: "visible",
          opacity: 0
        });
        tooltip.animate({ opacity: 1 }, 250);
      });

      // Escuchar On mouse leave:
      $(".slick-dots li").on("mouseleave", function (e) {
        $(".tooltip").css("visibility", "hidden");
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      this.slickCall();
      document.addEventListener('touchstart', function () {
        _this3.setState({ touchStart: event.touches[0].clientY });
      });

      this.handleAddOnBlurListener();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.carouselScroll === 0 && !this.bEventScroll) {
        this.scroll();
      }
      // }else {
      //   this.state.anioActive = null;
      // }
    }
  }, {
    key: "handleAddOnBlurListener",
    value: function handleAddOnBlurListener() {
      var addOnBlurListener = function addOnBlurListener(onBlurCallback, onFocusCallback) {

        var hidden, visibilityState, visibilityChange; // check the visiblility of the page

        if (typeof document.hidden !== "undefined") {
          hidden = "hidden";visibilityChange = "visibilitychange";visibilityState = "visibilityState";
        } else if (typeof document.mozHidden !== "undefined") {
          hidden = "mozHidden";visibilityChange = "mozvisibilitychange";visibilityState = "mozVisibilityState";
        } else if (typeof document.msHidden !== "undefined") {
          hidden = "msHidden";visibilityChange = "msvisibilitychange";visibilityState = "msVisibilityState";
        } else if (typeof document.webkitHidden !== "undefined") {
          hidden = "webkitHidden";visibilityChange = "webkitvisibilitychange";visibilityState = "webkitVisibilityState";
        }

        if (typeof document.addEventListener === "undefined" || typeof hidden === "undefined") {
          // not supported
        } else {
          document.addEventListener(visibilityChange, function () {
            switch (document[visibilityState]) {
              case "visible":
                if (onFocusCallback) onFocusCallback();
                break;
              case "hidden":
                if (onBlurCallback) onBlurCallback();
                break;
            }
          }, false);
        }
      };

      addOnBlurListener(this.muteAudioAddOnBlurListener, this.unMuteAudioAddOnBlurListener);
    }
  }, {
    key: "muteAudioAddOnBlurListener",
    value: function muteAudioAddOnBlurListener() {
      // console.log('mute all audios...');
      var videos = document.getElementsByTagName('video'),
          i = void 0,
          len = videos.length;
      for (i = 0; i < len; i++) {
        // console.log(videos[i]);
        if (!videos[i].muted) {
          // console.log("video mute ",videos[i]);
          videos[i].classList.add("videoMuteChangeTap");
          videos[i].muted = true;
          videos[i].pause();
        }
        // videos[i].muted = true;
      }
    }
  }, {
    key: "unMuteAudioAddOnBlurListener",
    value: function unMuteAudioAddOnBlurListener() {
      //console.log('unmute all audios...');
      var videos = document.getElementsByClassName('videoMuteChangeTap'),
          i = void 0,
          len = videos.length;
      for (i = 0; i < len; i++) {
        videos[i].muted = false;
        videos[i].play();
        videos[i].classList.remove("videoMuteChangeTap");
      }
    }
  }, {
    key: "scroll",
    value: function scroll() {
      this._eventScroll(true);
    }
  }, {
    key: "_eventScroll",
    value: function _eventScroll(boolean) {
      if (boolean) {
        this.bEventScroll = true;
        document.addEventListener("wheel", this.navigateScroll);
      } else {
        this.bEventScroll = false;
        document.removeEventListener("wheel", this.navigateScroll);
      }
    }
  }, {
    key: "_carouselScrollPrevSection",
    value: function _carouselScrollPrevSection() {
      //-1 no carousel
      //0 Carousel
      //1 Mover hacia arriba
      this.props.setCarouselScroll(1);
      //pausar vídeos y reiniciar
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this4 = this;

      this._eventScroll(false);
      document.removeEventListener('touchstart', function () {
        _this4.setState({ touchStart: event.touches[0].clientY });
      });
    }
  }, {
    key: "navigateScroll",
    value: function navigateScroll() {
      var _this5 = this;

      var increment = void 0;
      console.log(event);
      if (event.deltaY) {
        increment = event.deltaY > 0 ? 1 : -1;
      } else if (event.changedTouches) {
        // console.log('ENTRO AQUIIIIIIIII')
        var value = this.state.touchStart - event.changedTouches[0].clientY;
        increment = value > 0 ? 1 : -1;
      };

      if (!this.animation) {
        if (increment > 0) {
          //1 bajo
          // console.log("bajo");
          if (this.carouselActive) {
            this.nextSlider();
          }
        } else {
          //-1 subo
          // console.log("subo");
          if (this.carouselActive && this.state.slickItemActive > 0) {
            this.prevSlider();
          } else {
            //avisar a scroll que tiene que subir a explicación y dejamos de escuchar
            this._eventScroll(false);
            this._carouselScrollPrevSection();
          }
        }
        // this._eventScroll(false);
        this.animation = true;
        setTimeout(function () {
          _this5.animation = false;
          // this._eventScroll(true);
        }, 700);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _props = this.props,
          strings = _props.strings,
          carouselScroll = _props.carouselScroll;
      var mute = this.state.mute;


      var creditHtml = _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_components.Credits, null)
      );

      var classCarousel = (0, _classnames2.default)({
        "Carrousel": true,
        "Carrousel--active": carouselScroll === 0
      });

      var soundMutedHtml = null;
      if (!this.props.isMobile) {
        soundMutedHtml = _react2.default.createElement(_components.SoundMuted, { anioActive: this.state.anioActive, mute: mute, handleCarouselChangeMute: this.handleCarouselChangeMute, handleCarouselChangeYear: this.handleCarouselChangeYear });
      }

      var items = strings.carousel.map(function (elem, indexElem) {
        var videos = elem.videos.map(function (videosElem, indexVideosElem) {
          var leftOrRightStyle = indexVideosElem === 0 ? "videoLeft" : "videoRight";

          return _react2.default.createElement(
            "div",
            {
              className: "sliderItem__video " + leftOrRightStyle,
              key: "carouselVideosElem" + indexVideosElem
            },
            _react2.default.createElement(_components.ContainerVideo, {
              strings: videosElem,
              index: indexElem,
              id: "" + indexElem + indexVideosElem,
              slickItemActive: _this6.state.slickItemActive,
              anioActive: _this6.state.anioActive,
              handleCarouselChangeYear: _this6.handleCarouselChangeYear,
              handleNextSlider: _this6.nextSlider,
              handlePrevSlider: _this6.prevSlider,
              handleModal: _this6.props.handleModal,
              carouselScroll: carouselScroll,
              mute: mute
            })
          );
        });
        return _react2.default.createElement(
          "div",
          { key: "slider" + indexElem },
          _react2.default.createElement(
            "div",
            { className: "sliderItem" },
            videos
          )
        );
      });

      return _react2.default.createElement(
        "div",
        { className: classCarousel },
        _react2.default.createElement(
          "div",
          { className: "Carrousel__header" },
          _react2.default.createElement(
            "h1",
            { className: "Carrousel__header__title" },
            "Los 2 entierros ",
            _react2.default.createElement(
              "span",
              null,
              "de"
            ),
            " ",
            _react2.default.createElement(
              "span",
              null,
              "Franco"
            )
          )
        ),
        soundMutedHtml,
        _react2.default.createElement(
          "div",
          { className: "slick-slider" },
          items,
          creditHtml
        )
      );
    }
  }]);
  return Carousel;
}(_react2.default.Component)) || _class);
exports.default = Carousel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/Carousel.jsx
// module id = 690
// module chunks = 0